import * as React from "react";
import {Fragment} from "react";
import Create from "./Create";
import Import from "./Import";

class Configuration extends React.Component {

	constructor(props) {
		super(props);
	}

	render() {

		return (
			<Fragment>
				<Create />
				<Import />
			</Fragment>
		);
	}
}

export default Configuration;
